import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import {
  competitionAverageSelectedCompetitionsAtom,
  competitionAverageSelectedSeasonsAtom,
} from '@/atoms/filters/player/playerCompetitionAverageFilters';
import { unwrappedSelectedRadarTemplateAtom } from '@/atoms/radar';
import { Positions } from '@/components/radar/Positions';
import { BioTableContent } from '@/components/radar/table/RadarBioTable';
import { useRawPositionOptions } from '@/hooks/useRawPositionOptions';
import { convertToDropdownOption } from '@/utils/object';

// returns the comparison bio column for competition-average mode
export const usePlayerCompetitionAverageBioColumn = () => {
  const { t } = useTranslation(['radar', 'filters']);
  const selectedCompetitions = useAtomValue(competitionAverageSelectedCompetitionsAtom);
  const selectedSeasons = useAtomValue(competitionAverageSelectedSeasonsAtom);
  const selectedTemplate = useAtomValue(unwrappedSelectedRadarTemplateAtom);

  const positionOptions = useRawPositionOptions(
    (selectedTemplate?.definition.positions ?? []).map(position => convertToDropdownOption(position, position)),
  );

  return {
    name: t('competitionAverage.optionLabel', { ns: 'radar' }),
    competition: <BioTableContent options={selectedCompetitions} />,
    season: <BioTableContent options={selectedSeasons} />,
    team: '-',
    game: t('allGames', { ns: 'filters' }),
    position: <Positions options={positionOptions} />,
    dob: '-',
  };
};
